export const INSURED_STATUS = [
  {
    label: 'Ativo',
    value: 1,
  },
  {
    label: 'Inativo',
    value: 2,
  },
  {
    label: 'Pendente',
    value: 3,
  },
  {
    label: 'Inadimplente',
    value: 4,
  },
  {
    label: 'Pré-inadimplente',
    value: 5,
  },
  {
    label: 'Suspenso',
    value: 6,
  },
  {
    label: 'Em cancelamento',
    value: 7,
  },
  {
    label: 'Cancelado',
    value: 8,
  },
  {
    label: 'Finalizado',
    value: 9,
  }
];
